import React from "react";
import "./merchant-profile.css";
// import {
//   CopyIconV1,
//   ExternalLinkIconV1,
//   QrCodeIconV1,
//   RefreshIconV1,
// } from "images/image-component";
import BalanceCta, { BalanceCtaProps } from "features/balance-cta/BalanceCta";
import { Skeleton } from "components/skeleton";

interface Props extends BalanceCtaProps {
  logoLetter: string;
  name: string;
  category: string;
  status: string;
  memberSince: string;
  address: string;
  lifetimeAmount: string;
  lifetimeUnit: string;
  // Covers the whole identity block — logo, name and the status/category/member
  // row. Skeletoned together rather than field by field: they come from one
  // query, and a partly-filled row (a real category next to a "Unknown" status
  // that has not loaded yet) reads as data rather than as loading.
  infoLoading?: boolean;
  balanceLoading?: boolean;
  copied?: boolean;
  isRefreshing?: boolean;
  onCopy: () => void;
  onExplorer: () => void;
  onQr: () => void;
  onRefresh?: () => void;
}

function MerchantProfile({
  logoLetter,
  name,
  category,
  status,
  memberSince,
  address,
  lifetimeAmount,
  lifetimeUnit,
  infoLoading = false,
  balanceLoading = false,
  copied,
  isRefreshing = false,
  onCopy,
  onExplorer,
  onQr,
  onRefresh,
  merchantId,
  treasuryId,
  balance,
  tokenSymbol,
  settlementToken,
  pendingCount,
  guardsLoading,
  submitRedeem,
}: Props) {
  return (
    <section className="merchant-profile">
      <div className="merchant-profile__row">
        {infoLoading ? (
          // Matches .merchant-profile__logo's 76px box and 18px radius so the
          // layout does not shift when the real logo lands.
          <Skeleton width={76} height={76} borderRadius={18} />
        ) : (
          <div className="merchant-profile__logo">{logoLetter}</div>
        )}

        <div className="merchant-profile__info">
          {infoLoading ? (
            <>
              <div className="merchant-profile__name">
                <Skeleton width={220} height={24} />
              </div>
              <div className="merchant-profile__meta">
                <Skeleton width={260} height={13} />
              </div>
            </>
          ) : (
            <>
              <div className="merchant-profile__name">{name}</div>
              <div className="merchant-profile__meta">
                <span className="merchant-profile__status">{status}</span>
                <span className="merchant-profile__dot" />
                <span>{category}</span>
                <span className="merchant-profile__dot" />
                <span>Member since {memberSince}</span>
              </div>
            </>
          )}
        </div>

        <div className="merchant-profile__balance">
          <div className="merchant-profile_balance-info">
            <div className="merchant-profile__balance-label">Balance</div>
            <div className="merchant-profile__balance-value">
              {balanceLoading ? (
                <Skeleton width={90} height={26} />
              ) : (
                <>
                  {lifetimeAmount}
                  <span className="merchant-profile__balance-unit">
                    {lifetimeUnit}
                  </span>
                </>
              )}
            </div>
          </div>
          <BalanceCta
            merchantId={merchantId}
            treasuryId={treasuryId}
            balance={balance}
            tokenSymbol={tokenSymbol}
            settlementToken={settlementToken}
            pendingCount={pendingCount}
            guardsLoading={guardsLoading}
            submitRedeem={submitRedeem}
          />
        </div>
      </div>

      {/* <div className="merchant-profile__addr-row">
        <span className="merchant-profile__addr-label">Receiving</span>
        <span className="merchant-profile__addr">{address}</span>
        <button
          className="merchant-profile__mini-btn"
          aria-label={copied ? "Copied" : "Copy address"}
          onClick={onCopy}
        >
          <CopyIconV1 size={14} />
        </button>
        <button
          className="merchant-profile__mini-btn"
          aria-label="View in explorer"
          onClick={onExplorer}
        >
          <ExternalLinkIconV1 size={14} />
        </button>
        <button
          className="merchant-profile__mini-btn"
          aria-label="Show QR code"
          onClick={onQr}
        >
          <QrCodeIconV1 size={14} />
        </button>
        <button
          className={`merchant-profile__mini-btn${isRefreshing ? " merchant-profile__mini-btn--spinning" : ""}`}
          aria-label="Refresh data"
          onClick={onRefresh}
          disabled={isRefreshing}
        >
          <RefreshIconV1 size={14} />
        </button>
      </div> */}
    </section>
  );
}

export default MerchantProfile;
